<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-17 11:52:42
 * @LastEditTime: 2024-02-29 19:46:43
 * @Description:
 * @FilePath: \website\src\pages\aboutus\index.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
    <div>
        <el-carousel class="swiper" height="464px">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <el-image :src="item"></el-image>
            </el-carousel-item>
        </el-carousel>
        <SubMenu
            class="submenu"
            :menuList="menuList"
            @anchorTo="$anchorTo"
        ></SubMenu>
        <!-- 中国薯网是谁 -->
        <div class="introduce topic" id="abts1">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/introduce-topic-aboutus.png"
            ></Topic>
            <div class="introduce-main">
                <div class="introduce-text">
                    <div v-for="(item, index) in introduce" :key="index">
                        <div class="title">{{ item.title }}</div>
                        <div class="content">{{ item.content }}</div>
                    </div>
                </div>
                <div class="introduce-img">
                    <video
                        controls
                        poster="http://file.tudouec.com/%E4%B8%AD%E5%9B%BD%E8%96%AF%E7%BD%91%E5%AE%A3%E4%BC%A0%E7%89%87%E5%B0%81%E9%9D%A2.jpg"
                        src="http://file.tudouec.com/%E4%B8%AD%E5%9B%BD%E8%96%AF%E7%BD%91%E5%AE%A3%E4%BC%A0%E7%89%87.mp4"
                    ></video>
                </div>
            </div>
        </div>
        <div class="introduce-middle topic">
            <div>中国薯网·新直采新直销平台</div>
            <div>
                <div v-for="(item, index) in introduce2" :key="index">
                    {{ item.content }}
                </div>
            </div>
        </div>
        <div class="introduce-icons topic">
            <el-image v-for="(item, index) in imgList4"
                    :key="index"
                :src="`http://wwwadm.tudouec.com/profile/resource/www_img/${item.url}`"
            ></el-image>
        </div>
        <!-- 荣誉成果 -->
        <div class="honor topic" id="abts2">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/honor-topic-aboutus.png"
            ></Topic>
            <div class="honor-text">
                荣获中国社会工作联合会“中国优秀企业公民”、“中国中小企业节“、“创新100强企业称号”，进入《全国农村产业融合发展典型企业》名录和国家网络扶贫“双百”工程网信企业，是全国农产品加工产业发展联盟薯类产业专业委员会执委。
            </div>
            <div class="honor-line">
                <div>荣誉资质</div>
                <el-image
                    src="http://wwwadm.tudouec.com/profile/resource/www_img/honor-line-aboutus.png"
                ></el-image>
            </div>
            <el-row :gutter="100">
                <el-col
                    v-for="(item, index) in imgList1"
                    :key="index"
                    :span="8"
                >
                    <el-image
                        :src="`http://wwwadm.tudouec.com/profile/resource/www_img/${item.url}`"
                    ></el-image>
                    <div class="honor-name">{{ item.title }}</div>
                </el-col>
            </el-row>
            <div class="honor-line">
                <div>科研成果</div>
                <el-image
                    src="http://wwwadm.tudouec.com/profile/resource/www_img/honor-line-aboutus.png"
                ></el-image>
            </div>
            <div class="honor-certificate">
                <div v-for="(item, index) in imgList2" :key="index">
                    <el-image
                        :src="`http://wwwadm.tudouec.com/profile/resource/www_img/${item.url}`"
                    ></el-image>
                    <div class="honor-name">{{ item.title }}</div>
                </div>
            </div>
        </div>
        <!-- 大事件 -->
        <div class="events topic" id="abts3">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/events-topic-aboutus.png"
            ></Topic>
            <EventsLine :events="events"></EventsLine>
        </div>
        <!-- 合作伙伴 -->
        <div class="partner topic" id="abts4">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/partner-topic-aboutus.png"
            ></Topic>
            <el-row :gutter="24">
                <el-col
                    v-for="(item, index) in imgList3"
                    :key="index"
                    :span="6"
                >
                    <el-image
                        v-if="item.url != ''"
                        :src="`http://wwwadm.tudouec.com/profile/resource/www_img/${item.url}`"
                    ></el-image>
                    <div class="title" v-if="item.title != ''">
                        {{ item.title }}
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 联系我们 -->
        <div class="contact topic" id="abts5">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/contact-topic-aboutus.png"
            ></Topic>
            <div id="map"></div>
            <div class="map-card">
                <div class="title">中国薯网·内蒙古金豆农业科技有限公司</div>
                <el-row>
                    <el-col :span="17">
                        全国客服热线 0471-3371777 <br />
                        网址：www.jd-nk.com<br />
                        邮箱：tudouec@163.com<br />
                        地址：内蒙古呼和浩特市赛罕区<br />
                        金桥电子商务产业园403室
                    </el-col>
                    <el-col :span="7">
                        <el-image
                            src="http://wwwadm.tudouec.com/profile/resource/www_img/qrcode-aboutus.png"
                        ></el-image>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
import EventsLine from "../../components/EventsLine.vue";
export default {
    components: { EventsLine },
    data() {
        return {
            bannerList: [
                "http://wwwadm.tudouec.com/profile/resource/www_img/banner-aboutus.png",
            ],
            menuList: [
                { name: "中国薯网是谁", anchorId: "abts1" },
                { name: "企业荣誉", anchorId: "abts2" },
                { name: "大事件", anchorId: "abts3" },
                { name: "合作伙伴", anchorId: "abts4" },
                { name: "联系我们", anchorId: "abts5" },
            ],
            introduce: [],
            introduce2: [],
            imgList1: [],
            imgList2: [],
            imgList3: [],
            imgList4: [],
            events: [],
        };
    },
    mounted() {
        this.$api.getIntroduceJson("aboutus").then((res) => {
            this.introduce = res.introduce;
            this.introduce2 = res.introduce2;
            this.imgList1 = res.imgList1;
            this.imgList2 = res.imgList2;
            this.imgList3 = res.imgList3;
            this.imgList4 = res.imgList4;
            this.events = res.events;
        });
        this.mapInit();
    },
    methods: {
        // 初始化地图
        mapInit() {
            let that = this;
            // 在页面渲染完成后进行地图的实例化
            this.$nextTick(() => {
                that.map = new TMap.Map(document.getElementById("map"), {
                    // 地图的中心地理坐标。
                    center: new TMap.LatLng(40.771588, 111.741726),
                    zoom: 14,
                });
                new TMap.MultiMarker({
                    map: that.map,
                    styles: {
                        // 点标记样式
                        marker: new TMap.MarkerStyle({
                            width: 20, // 样式宽
                            height: 30, // 样式高
                            anchor: { x: 10, y: 30 }, // 描点位置
                        }),
                    },
                    geometries: [
                        // 点标记数据数组
                        {
                            // 标记位置(纬度，经度，高度)
                            position: new TMap.LatLng(
                                40.771679,
                                111.730659,
                                20
                            ),
                            id: "marker",
                        },
                    ],
                });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/.swiper {
    .el-carousel__indicators--horizontal {
        left: 360px;
        bottom: 15%;
    }
}
.introduce {
    margin-top: 64px;
    .introduce-main {
        display: flex;
        justify-content: space-between;
        .introduce-text {
            flex-basis: 50%;
            .title {
                color: $color-main;
                font-size: $font-size-m;
            }
            & > div + div {
                margin-top: 20px;
            }
            .content {
                text-indent: 32px;
            }
        }
        .introduce-img > video {
            width: 504px;
        }
    }
}
.introduce-middle {
    margin-top: 64px;
    background-color: #f5f5f5;
    padding: {
        top: 40px;
        bottom: 48px;
    }

    > :first-child {
        font-size: $font-size-xl;
        color: $color-main;
        font-weight: bold;
        margin-bottom: 20px;
    }
    > div > div:not(:last-of-type) {
        margin-bottom: 32px;
    }
}
.introduce-icons {
    // padding: 72px auto;
    margin: 72px 0;
    display: flex;
    justify-content: space-around;
    .el-image {
        width: 168px;
    }
}
.honor {
    .honor-text {
        margin-top: 32px;
    }
    .honor-line {
        display: flex;
        align-items: center;
        margin-top: 32px;
        :first-child {
            color: $color-title;
            font-size: $font-size-l;
            font-weight: 600;
            margin-right: 12px;
            flex-basis: 85px;
            line-height: 28px;
        }
        .el-image {
            height: 5px;
        }
    }
    .honor-name {
        text-align: center;
        margin: 20px auto;
    }
    .el-col {
        .el-image {
            margin-top: 20px;
        }
    }
    .honor-certificate {
        display: flex;
        justify-content: space-between;
        > div {
            margin-top: 20px;
        }
        > div + div {
            margin-left: 50px;
        }
    }
}
.events {
    background-image: url("http://wwwadm.tudouec.com/profile/resource/www_img/events-bg-aboutus.png");
    background-size: cover;
    margin-top: 32px;
    padding: {
        top: 40px;
        bottom: 40px;
    }
    height: 667px;
}
.partner {
    background-color: #ffffff;
    padding: {
        top: 104px;
        bottom: 104px;
    }
    .el-image,
    .title {
        width: 282px;
        height: 100px;
        margin-bottom: 24px;
        background-color: #fafafa;
    }
    .title {
        color: $color-main;
        font-size: $font-size-l;
        font-weight: 600;
        text-align: center;
        line-height: 100px;
    }
}
.contact {
    padding: {
        top: 40px;
        bottom: 104px;
    }
    position: relative;
    #map {
        width: 1200px;
        height: 390px;
    }
    .map-card {
        background-color: #ffffff;
        width: 420px;
        height: 220px;
        padding: 32px;
        position: absolute;
        top: 216px;
        right: 420px;
        .title {
            color: $color-main;
            font-size: $font-size-m;
            font-weight: 600;
            margin-bottom: 32px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutus/index.vue